import { Trans } from 'react-i18next'

import translationKeys from '@translationKeys'

import ProfileAlertButton from '@modules/alerts/components/ProfileAlertButton'
import ContactedBubble from '@modules/chat/components/ContactedBubble'
import { ProfileType } from '@modules/search/types'
import { Button } from '@mui/material'

import { ContactButtonWrapper } from '../index.styles'
import { CellInfo } from '../types'

export const ProfileContactCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
    meta: { hasAccessToAlerts, isEcommerce, hasAccessToChat, isContactButtonEnabled, alertsShortlistId, onContactClick },
  } = info

  if (profileData.profileImgData?.isPrivate && !profileData.profileHasPublicEvent) {
    return null
  }

  return (
    <>
      {hasAccessToAlerts && (
        <ProfileAlertButton
          alertsShortlistId={alertsShortlistId}
          profile={{ id: profileData.globalId, '@type': profileData.profileType }}
          savedProfileAlert={profileData.profileAlert}
        />
      )}
      {hasAccessToChat && !isEcommerce && isContactButtonEnabled(profileData.companyId) && profileData.isContactable && (
        <ContactButtonWrapper>
          <ContactedBubble hasContacted={profileData.hasContacted}>
            <Button
              onClick={e => onContactClick(e, profileData)}
              color="primary"
              variant="contained"
              size="small"
              id={`contact_button-${
                profileData.profileType === ProfileType.delegate ? profileData.profileType : ProfileType.company
              }`}
            >
              <Trans>{translationKeys.CUSTOM_LIST_TABLE_CONTACT_BUTTON}</Trans>
            </Button>
          </ContactedBubble>
        </ContactButtonWrapper>
      )}
    </>
  )
}
